import { useFmsNotificationsContext } from 'context/FmsNotificationsContext'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { buildNotificationReadContext } from 'utils/notificationClient'

/** Mark read only when user opened the app from a system push (notification_read query). */
export function FmsNotificationRouteSync() {
  const location = useLocation()
  const navigate = useNavigate()
  const { markRead } = useFmsNotificationsContext()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const raw = params.get('notification_read')
    if (!raw) {
      return
    }
    const id = Number(raw)
    if (!Number.isFinite(id) || id <= 0) {
      return
    }

    markRead(id, buildNotificationReadContext('push_click'))

    params.delete('notification_read')
    const nextSearch = params.toString()
    navigate({ pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : '' }, { replace: true })
  }, [location.pathname, location.search, markRead, navigate])

  return null
}
